// 系列化课程
import React from "react";
import { WizClassifySelect } from "../../index";

const columns = () => {
	return [
		{
			name: 'id',
		},
		{
			title: '名称',
			name: 'name',
			dataIndex: "name",
			searchItem: {},
			tableItem: {
        width: 300
      },
		},
		{
			title: "分类",
			name: "seriesCategoryIds",
			dataIndex: "seriesCategoryIds",
			searchItem: {
				type: 'diy',
				diy: WizClassifySelect,
				returnKey: true,
				wizTreeSelectListProps: {
					itemProps: {
						icon: 'unordered-list',
						title: '标签分类',
						tips: '请勾选所属标签分类'
					},
					treeProps: { checkStrictly: true }
				},
				apiProps: { type: 7 ,state:1 },
				selectProps: {
					placeholder: '请选择标签分类'
				},
			},
		},
		{
			title: "分类",
			name: "seriesCategoryName",
			dataIndex: "seriesCategoryName",
			tableItem: {
			  width: 450
      },
		},
		{
			title: "状态",
			name: "state",
			dataIndex: "state",
			tableItem: {},
			dict: [
				{ code: 1, codeName: "有效" },
				{ code: 0, codeName: "无效" }
			],
		},
	]
}

const tableApi = (api = {}) => {
	return {
		path: 'series/getListByPage',
		...api
	}
}


const series = (self, api) => {
	return {
		type: 'diy',
		initialValue: [],
		columns: columns(),
		rowName: 'name',
		cols: {
			xs: 12,
			md: 12,
			xl: 12
		},
		tableApi: tableApi(api)
	}
}

export default series
